import { useEffect } from "react";
const getFileSize = (size) => {
  if (size === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(size) / Math.log(k));
  return `${parseFloat((size / k ** i).toFixed(2))} ${sizes[i]}`;
};
const getFileType = (fileName) => fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length) || fileName;
const detectClickOutside = (ref, callback) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (event.target === null) {
        return;
      }
      if (ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });
};
const sortObjectsByProp = (objects, prop, ascending = true) => {
  const compare = (a, b) => {
    if (a[prop] < b[prop]) {
      return ascending ? -1 : 1;
    }
    if (a[prop] > b[prop]) {
      return ascending ? 1 : -1;
    }
    return 0;
  };
  return [...objects].sort(compare);
};
const sortObjectsPropByProp = (objects, objectsProp, prop, ascending = true) => {
  const compare = (a, b) => {
    if (a[prop][objectsProp] < b[prop][objectsProp]) {
      return ascending ? -1 : 1;
    }
    if (a[prop][objectsProp] > b[prop][objectsProp]) {
      return ascending ? 1 : -1;
    }
    return 0;
  };
  return [...objects].sort(compare);
};
const groupObjects = (objects, groupBy) => objects == null ? void 0 : objects.reduce((accum, object) => {
  const updated = { ...accum };
  if (Object.hasOwnProperty.call(updated, object[groupBy])) {
    updated[object[groupBy]].push(object);
  } else {
    updated[object[groupBy]] = [object];
  }
  return updated;
}, {});
const formatCurrency = (value, useDecimals = true, invalidValue = "$0", options) => {
  const language = (options == null ? void 0 : options.language) ?? "en-AU";
  const currency = (options == null ? void 0 : options.currency) ?? "AUD";
  const currencySymbol = (options == null ? void 0 : options.currencySymbol) ?? "$";
  if (value === null || Number.isNaN(value)) {
    return invalidValue;
  }
  let newValue = `${value}`;
  if (newValue.includes(currencySymbol)) {
    newValue = newValue.replace(currencySymbol, "");
  }
  const parsedValue = parseFloat(newValue);
  if (Number.isNaN(parsedValue)) {
    return invalidValue;
  }
  const formatter = new Intl.NumberFormat(language, {
    style: "currency",
    currency,
    minimumFractionDigits: useDecimals ? 2 : 0,
    maximumFractionDigits: 2
  });
  return formatter.format(parsedValue).toLocaleString();
};
const toCapitalizedWords = (name) => {
  const words = name.match(/[A-Za-z][a-z]*/g) || [];
  return words.map(capitalize).join(" ");
};
const capitalize = (word) => word.charAt(0).toUpperCase() + word.substring(1);
const findObjectByProperty = (objects, id, property = "objectId") => objects == null ? void 0 : objects.find((obj) => (obj == null ? void 0 : obj[property]) === id);
const objectExists = (objects, id, property = "objectId") => objects == null ? void 0 : objects.includes((obj) => (obj == null ? void 0 : obj[property]) === id);
const isSet = (value) => value !== null && value !== void 0;
const findObjectIndexByProperty = (objects, id, property = "objectId") => objects == null ? void 0 : objects.findIndex((obj) => (obj == null ? void 0 : obj[property]) === id);
const emptyObject = (value) => value && Object.keys(value).length === 0 && Object.getPrototypeOf(value) === Object.prototype;
const isVoid = (item) => item === null || item === void 0;
const isEmpty = (item) => {
  if (item === null || item === void 0) {
    return true;
  }
  if (Object.getPrototypeOf(item) === Object.prototype) {
    return item && Object.keys(item).length === 0;
  }
  if (item.constructor === Array) {
    return (item == null ? void 0 : item.length) === 0;
  }
  return item === "";
};
const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
const isObject = (obj) => obj && typeof obj === "object" && !Array.isArray(obj);
const mergeDeep = (target, source, depth = 0, maxDepth = 20) => {
  const output = { ...target };
  if (depth < maxDepth && isObject(target) && isObject(source)) {
    const newDepth = depth + 1;
    Object.keys(source).forEach((key) => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          Object.assign(output, { [key]: source[key] });
        } else {
          output[key] = mergeDeep(target[key], source[key], newDepth, maxDepth);
        }
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
};
const noop = () => {
};
const generateRandomString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
const helpers = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize,
  detectClickOutside,
  emptyObject,
  findObjectByProperty,
  findObjectIndexByProperty,
  formatCurrency,
  generateRandomString,
  getFileSize,
  getFileType,
  groupObjects,
  isEmpty,
  isObject,
  isSet,
  isValidEmail,
  isVoid,
  mergeDeep,
  noop,
  objectExists,
  sortObjectsByProp,
  sortObjectsPropByProp,
  toCapitalizedWords
}, Symbol.toStringTag, { value: "Module" }));
export {
  isEmpty as a,
  findObjectByProperty as b,
  isSet as c,
  detectClickOutside as d,
  getFileSize as e,
  findObjectIndexByProperty as f,
  generateRandomString as g,
  helpers as h,
  isVoid as i,
  getFileType as j,
  sortObjectsPropByProp as k,
  groupObjects as l,
  formatCurrency as m,
  capitalize as n,
  objectExists as o,
  emptyObject as p,
  isValidEmail as q,
  isObject as r,
  sortObjectsByProp as s,
  toCapitalizedWords as t,
  mergeDeep as u,
  noop as v
};
//# sourceMappingURL=helpers-N4qF49_T.js.map
